(function () {
  var dialog = document.getElementById('newsletter-popup');
  if (!dialog) return;

  var closeBtn = document.getElementById('newsletter-popup-close');
  var STORAGE_KEY = 'zeravel_newsletter_popup_dismissed';

  function close() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
    if (dialog.open) dialog.close();
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', close);
  }

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) close();
  });

  dialog.addEventListener('cancel', function () {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  });

  if (dialog.hasAttribute('open')) {
    // Server-side already opened it (e.g. after successful signup) — nothing more to do.
    return;
  }

  var alreadyDismissed = false;
  try {
    alreadyDismissed = localStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {}

  if (alreadyDismissed) return;

  window.setTimeout(function () {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  }, 6000);
})();
